import React from 'react';
import { Section } from './ui/Section';
import { AlertCircle, XCircle } from 'lucide-react';
export function PainPoints() {
  return <>
      <Section background="white" data-id="element-104">
        <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-106">
            ¿Te suena familiar esta escena?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-107">
            "Levántate." "Ponte la ropa." "Los dientes." "¡Vamos tarde!"
          </p>
          <div className="p-6 bg-red-50 rounded-2xl border border-red-100 my-8" data-id="element-108">
            <p className="text-lg text-gray-700 italic" data-id="element-109">
              Y en ese punto, aunque ames a tu hijo con todo, ya vas con el
              cuerpo tenso, la voz alta y el corazón culpable.
            </p>
          </div>
          <p className="text-gray-600" data-id="element-110">
            No es porque estés fallando como mamá o papá. Es porque estás
            intentando manejar{' '}
            <span className="font-bold text-[#E8845F]" data-id="element-111">
              transiciones invisibles
            </span>{' '}
            con palabras.
          </p>
        </div>
      </Section>

      <Section background="cream" data-id="element-112">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-113">
          <div data-id="element-114">
            <h3 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-115">
              Por qué "lo que ya intentaste" no funciona
            </h3>
            <div className="space-y-6" data-id="element-116">
              {[{
              title: 'Gritar',
              desc: 'Funciona 1 vez... y después necesitas gritar más fuerte.'
            }, {
              title: 'Castigar en caliente',
              desc: 'Convierte la mañana en una guerra de poder.'
            }, {
              title: 'Premiar improvisando',
              desc: "Crea la frase que destruye todo: '¿y qué me das?'"
            }, {
              title: 'Explicar demasiado',
              desc: 'Cuando ya está desregulado, solo alarga el caos.'
            }].map((item, idx) => <div key={idx} className="flex items-start" data-id="element-117">
                  <XCircle className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-1" data-id="element-118" />
                  <div data-id="element-119">
                    <h4 className="font-bold text-gray-900" data-id="element-120">{item.title}</h4>
                    <p className="text-gray-600" data-id="element-121">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="bg-white p-8 rounded-3xl shadow-xl border-2 border-[#E6F4F4]" data-id="element-122">
            <div className="flex items-center justify-center w-16 h-16 bg-[#E6F4F4] rounded-full mb-6 mx-auto" data-id="element-123">
              <AlertCircle className="w-8 h-8 text-[#4AAAA5]" data-id="element-124" />
            </div>
            <h3 className="text-2xl font-bold text-center text-gray-900 mb-4" data-id="element-125">
              La verdad incómoda
            </h3>
            <p className="text-center text-gray-600 mb-6" data-id="element-126">
              Cuando un niño no puede anticipar lo que viene, intenta recuperar
              control con lo único que tiene: resistencia, llanto y "no".
            </p>
            <div className="text-center" data-id="element-127">
              <span className="inline-block bg-[#F5C842] text-gray-900 font-bold px-4 py-2 rounded-lg transform -rotate-1" data-id="element-128">
                No te falta amor. Te falta un sistema.
              </span>
            </div>
          </div>
        </div>
      </Section>
    </>;
}